import { FlashOnStellarClientV2 } from '@flashbacktech/flashbackclient/stellarv2';

enum TabIndex {
  Dashboard = 0,
  CloudStorage = 1,
  StorageUnits = 2,
  StorageRepos = 3,
  BridgeNodes = 4,
  Performance = 5,
  Metrics = 6,
  FileExplorer = 7,
  Activity = 8,
  Feedback = 9,
  Documentation = 10,
  StripeTest = 11,
  BridgeNodesPublic = 12,
  BridgeNodesPrivate = 13,
  Marketplace = 14,
  MyDeals = 15,
  StorageUnitsDePIN = 16,
  AILLM = 17,
  Home = 18,
  AIStatistics = 19,
  Organization = 20,
  AIOverview = 21,
  ActivationLinks = 22,
  AIViolations = 23,
  APIKeys = 24,
  AIPolicies = 25,
  StellarBuckets = 26,
  StellarMarketplace = 27,
  StellarMyDeals = 28,
  RepoOverview = 29,
  Hub = 30,
  Chat = 31,
  ResourceAPIKeys = 32,
}

interface TabPropsV2 {
  wallet_address: string | null;
  owner_address: string | null;
  client: FlashOnStellarClientV2 | null;
}

interface CanBeAddressed {
  tab_address: string | null;
}

interface CanSetAddress {
  setTabAddress: (value: string | null) => void;
}

interface CanSignTransaction {
  signTransaction: (txXDR: string) => Promise<string>;
}

interface CanNavigate {
  setTabValue: (value: number) => void;
}

export { TabIndex };
export type { TabPropsV2, CanBeAddressed, CanSetAddress, CanSignTransaction, CanNavigate };
